import { useRef } from 'react';

export const useSubmitGuard = () => {
  const submittedRef = useRef(false);

  const reset = () => {
    submittedRef.current = false;
  };

  const guard = <T>(fn: (data: T) => void | Promise<void>) => {
    return (data: T) => {
      if (submittedRef.current) {
        return;
      }
      submittedRef.current = true;
      fn(data);
    };
  };

  return { guard, reset };
};
